var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapricorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.4585C18.75 9.80089 18.0915 8.21118 16.9194 7.03908C15.7473 5.86698 14.1576 5.2085 12.5 5.2085C10.8424 5.2085 9.25269 5.86698 8.08058 7.03908C6.90848 8.21118 6.25 9.80089 6.25 11.4585M18.75 11.4585V30.2085M18.75 11.4585C18.75 9.80089 19.4085 8.21118 20.5806 7.03908C21.7527 5.86698 23.3424 5.2085 25 5.2085C26.6576 5.2085 28.2473 5.86698 29.4194 7.03908C30.5915 8.21118 31.25 9.80089 31.25 11.4585V37.2397C31.25 37.2397 31.25 44.7918 22.9167 44.7918",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 37.5C40.9518 37.5 43.75 34.7018 43.75 31.25C43.75 27.7982 40.9518 25 37.5 25C34.0482 25 31.25 27.7982 31.25 31.25C31.25 34.7018 34.0482 37.5 37.5 37.5Z",
    stroke: "black",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapricorn);
export default __webpack_public_path__ + "static/media/capricorn.f3c2032d86559d9c20160b4c0b108710.svg";
export { ForwardRef as ReactComponent };